export default __webpack_public_path__ + "static/media/yelImg.58256b29.png";